import React, {useCallback, useState} from "react";
import {useSelector} from "react-redux";
import CustomModal from "../../../components/CustomModal";
import CustomButton, {DangerButton} from "../../../components/CustomButton";
import getDynamicItemFor from "../selected/DynamicItemMapper";
import useDidMount from "../../../hooks/useDidMount";
import {getUiBreadCrumbFormat, isAllPlatform, isMobilePlatform, isWebPlatform} from "../dynamicUiFunctions";
import PlatformToggle from "../../../components/PlatformToggle";

export const PreviewModal = React.memo(
  ({setShowModal, showModal, disabled, onConfirm}) => {
    // const {
    //   loading,
    //   data: selectedDataList,
    //   error
    // } = useSelector((state) => state.dynamicUi.selected);

    const selectedPage = useSelector((state) => (state.dynamicUi.pages.selectedPage));

    const {
      loading=false,
      data: selectedDataList = [],
      error = ""
    } = useSelector((state) => state.dynamicUi.selected[selectedPage]) ?? {};

    const [mobileView, setMobileView] = useState(true);

    const isPlatformMobile = useSelector((state) => state.dynamicUi.isPlatformMobile);

    useDidMount(() => {
      if (showModal?.preview) {
        if (isAllPlatform(showModal.platform)) {
          setMobileView(isPlatformMobile);
        } else if ((isMobilePlatform(showModal.platform) && !mobileView) || (isWebPlatform(showModal.platform) && mobileView)) {
          setMobileView(!mobileView);
        }
      }
    }, [showModal]);

    const dataSelection = showModal?.id
      ? selectedDataList.find((i) => showModal.id === i.section?.id)
      : undefined;

    const onAddOrRemove = useCallback(() => {
      onConfirm(
        dataSelection
          ? {...showModal, remove: true, sectionId: dataSelection.id}
          : showModal
      );
    }, [onConfirm, showModal]);

    return (
      <CustomModal
        showModal={showModal}
        setShowModal={setShowModal}
        title={getUiBreadCrumbFormat(showModal)}
        bodyClasses={mobileView ? 'max-w-md' : 'max-w-6xl'} loading={disabled}
        isPreviewModal={true}
        preFooterComponent={
          isAllPlatform(showModal?.platform) &&
            <PlatformToggle mobileView={mobileView} mobileOnClick={() => setMobileView(true)} webOnClick={() => setMobileView(false)}/>
        }
        button={
          <div>
            {(!loading && !error) &&
            dataSelection ? <DangerButton onClick={onAddOrRemove}
                                          disabled={disabled}>Remove</DangerButton> :
              <CustomButton onClick={onAddOrRemove}
                            disabled={disabled}>Add</CustomButton>}
          </div>}
        >
        <div className={mobileView ? 'mobile' : 'web'}>
          {!!showModal?.preview ? getDynamicItemFor(showModal, {mobile: mobileView}) : ''}
        </div>
      </CustomModal>
    );
  });